import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { UnitFamily, UnitFamilyTypeMap } from '../models/enums/unit-families';
import { AuthService } from '../services/auth.service';

@Pipe({
  name: 'uom'
})
export class UomPipe implements PipeTransform, OnDestroy {

  unitFamilySub: Subscription;
  unitFamily: UnitFamily;

  unitMap = UnitFamilyTypeMap;

  constructor(
    private auth: AuthService,
    private translate: TranslateService) {
    this.unitFamilySub = this.auth.unitFamily$.subscribe(unitFamily => this.unitFamily = unitFamily);
  }

  private _dispose() {
    this.unitFamilySub?.unsubscribe();
  }

  /**
   * TODO decide to translate here or chained
   *
   * @param value
   * @param key
   * @returns
   */
  transform(value: any, abbrev: boolean = true): string {
    const mapping = this.unitMap?.get(this.unitFamily);
    if (mapping == null) return value;
    const result = abbrev === true ? mapping.abbrev[value] : mapping[value];
    return result || value;
  }

  ngOnDestroy(): void {
    this._dispose();
  }

}
